/* eslint-disable max-len */
import * as req from 'api/actions';
import * as c from './constant';

export const getBusinessList = (payload, callback) => req.list( // SIDEBAR BUSINESS LIST
  c.GET_BUSINESS_LIST,
  'api/v1/administrators/businesses', // url
  payload,
  callback,
);

export const getLineBusinessList = (payload, callback) => req.list(
  c.GET_LINE_BUSINESS,
  'api/v1/administrators/line_businesses',
  payload,
  callback,
);

export const getBusinessInfo = (id, payload, callback) => req.item( // GET SIDEBAR BUSINESS INFO
  c.GET_BUSINESS_INFO,
  `api/v1/administrators/businesses/${id}`, // url
  payload,
  callback,
);

export const rejectBusiness = (id, payload, callback) => req.update( // REJECT BUSINESS
  c.REJECT_BUSINESS,
  `api/v1/administrators/transaction_histories/${id}?status=REJECT`,
  payload,
  callback,
);

export const getBusinessTransactionHistoryList = (id, payload, callback) => req.list( // BUSINESS'S TRANSACTION HISTORY LIST
  c.GET_BUSINESS_TRANSACTION_HISTORY_LIST,
  `api/v1/administrators/businesses/${id}/transaction_histories`,
  payload,
  callback,
);

export const getBusinessTransactionHistoryItem = (businessId, id, payload, callback) => req.item(
  c.GET_BUSINESS_TRANSACTION_HISTORY_ITEM,
  `api/v1/administrators/businesses/${businessId}/transaction_histories/ ${id}`,
  payload,
  callback,
);


export const getBusinessFixTaxList = (id, payload, callback) => req.list( // GET LIST BASED ON BUSINESS
  c.GET_BUSINESS_FIX_TAX_LIST,
  `api/v1/administrators/businesses/${id}/business_fix_tax_settings`, // url
  payload,
  callback,
);

export const getFixTaxList = (payload, callback) => req.list(
  c.GET_FIX_TAX_LIST,
  'api/v1/administrators/businesses/business_fix_tax_settings/fixed_taxes',
  payload,
  callback,
);

export const getBusinessFixTaxInfo = (businessId, id, payload, callback) => req.item(
  c.GET_FIX_TAX_INFO,
  `api/v1/administrators/businesses/${businessId}/business_fix_tax_settings/${id}`,
  payload,
  callback,
);

export const addBusinessFixTax = (businessId, payload, callback) => req.create(
  c.ADD_BUSINESS_FIX_TAX,
  `api/v1/administrators/businesses/${businessId}/business_fix_tax_settings`,
  payload,
  callback,
);

export const updateFixTax = (businessId, id, payload, callback) => req.update(
  c.UPDATE_FIX_TAX,
  `api/v1/administrators/businesses/${businessId}/business_fix_tax_settings/${id}`,
  payload,
  callback,
);

export const deleteFixTax = (businessId, id, payload, callback) => req.remove( // DELETE SINGLE FIX TAX
  c.DELETE_FIX_TAX,
  `api/v1/administrators/businesses/${businessId}/business_fix_tax_settings/${id}`, // url
  payload,
  callback,
);


// OTHER FEES
export const getOtherFeeList = (payload, callback) => req.list(
  c.GET_OTHER_FEE_LIST,
  'api/v1/administrators/business_other_fees',
  payload,
  callback,
);

export const computeBusinessActivity = (payload, callback) => req.create(
  c.COMPUTE_BUSINESS_ACTIVITY,
  'api/v1/administrators/transaction_histories/business_activities/compute',
  payload,
  callback,
);

// COMPUTATION
export const computeFixedTax = (payload, callback) => req.create(
  c.COMPUTE_FIX_TAX,
  'api/v1/administrators/transaction_histories/business_fixed_taxes/compute',
  payload,
  callback,
);

export const computeOtherFee = (payload, callback) => req.create(
  c.COMPUTE_OTHER_FEE,
  'api/v1/administrators/transaction_histories/business_other_fees/compute',
  payload,
  callback,
);

// FOR FINAL SUBMITION
export const approveBusiness = (id, payload, callback) => req.update( // APPROVE BUSINESS
  c.APPROVE_BUSINESS,
  `api/v1/administrators/transaction_histories/${id}/process_business`, // url
  payload,
  callback,
);

export const startAssessment = (id, callback) => req.update(
  c.START_ASSESSMENT,
  `api/v1/administrators/transaction_histories/${id}/start_assessment`,
  callback,
  ({ res }) => {
    const { data } = res.res;
    if (callback) callback({ data });
  },
);


// export const item = (constant, url, callback, params, cacheKey) => ({
//   x: (() => console.log(constant, url, callback, params, cacheKey))(),
//   type: c.GET_ITEM,
//   key: constant,
//   url,
//   callback,
//   params,
//   cacheKey,
// });
